import { ThemeFreespinCelebrationState } from "./theme-freespin-celebration-state";
export class ThemeFreespinRetriggerCelebrationState extends ThemeFreespinCelebrationState {

}
